import { CheckCircle2 } from "lucide-react";
import { PIPELINE_STEPS } from "./salaryTemplatePipeline";
import "../../../../../styles/salary-template-pipeline.css";

const STEPS = [
  { n: PIPELINE_STEPS.template, label: "Structure" },
  { n: PIPELINE_STEPS.components, label: "Components" },
  { n: PIPELINE_STEPS.formulas, label: "Formulas" },
  { n: PIPELINE_STEPS.ctcAllocation, label: "Gross salary" },
  { n: PIPELINE_STEPS.review, label: "Review" },
];

export default function SalaryTemplatePipelineBar({ currentStep, compact = false }) {
  const step = Number(currentStep) || PIPELINE_STEPS.template;

  return (
    <nav
      className={`stp-pipeline-bar${compact ? " stp-pipeline-bar--compact" : ""}`}
      aria-label="Salary structure progress"
    >
      <p className="stp-pipeline-eyebrow">Salary structure</p>
      <ol className="stp-pipeline-steps">
        {STEPS.map((s, i) => {
          const done = step > s.n;
          const active = step === s.n;
          return (
            <li
              key={s.n}
              className={`stp-pipeline-step${active ? " is-active" : ""}${done ? " is-done" : ""}`}
            >
              <span className="stp-pipeline-dot" aria-hidden>
                {done ? <CheckCircle2 size={14} /> : active ? "●" : "○"}
              </span>
              <span className="stp-pipeline-label">{s.label}</span>
              {i < STEPS.length - 1 ? (
                <span className="stp-pipeline-sep" aria-hidden>
                  →
                </span>
              ) : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
